import React from 'react';
import UserLog from "../../../components/pages/grid/UserLog/UserLog";

const UserLogGridPage = () => {
    return <UserLog />
};

export default UserLogGridPage;